import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ScPromoCodeInput } from '@/components/Deposit/components/InputPromo/styled';
import { Input } from '@/components/form/Input';
import { ThemeMode } from '@/helpers/enums';

const REG_BONUS_CODE_FIELD = 'registrationBonusCode';

export const RegistrationPromoInput: FC = () => {
  const { t } = useTranslation();

  return (
    <ScPromoCodeInput mode={ThemeMode.Light}>
      <Input
        mode={ThemeMode.Light}
        name={REG_BONUS_CODE_FIELD}
        placeholder={t('deposits:inputPromo.placeholder')}
      />
    </ScPromoCodeInput>
  );
};
